var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroStar3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.564,
    height: 23.565,
    viewBox: "0 0 23.564 23.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M20.025,11.06c-5.109,1.86-7.105,3.855-8.965,8.965a.828.828,0,0,1-1.554,0C7.646,14.915,5.65,12.92.541,11.06a.828.828,0,0,1,0-1.554C5.65,7.647,7.646,5.65,9.506.542a.828.828,0,0,1,1.554,0c1.86,5.109,3.856,7.105,8.965,8.965a.828.828,0,0,1,0,1.554",
    transform: "translate(1.499 1.5)",
    fill: "none",
    stroke: "#f3f1e4",
    strokeWidth: 3,
    opacity: 0.205
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroStar3);
export default __webpack_public_path__ + "static/media/hero-star-3.dfbf5dcd56a22f659b6ac7a60f3918bf.svg";
export { ForwardRef as ReactComponent };